import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from '~/App'
import { applyStoredTheme } from '~/lib/theme'
import '~/styles/application.css'

applyStoredTheme()

const container = document.getElementById('root')

if (container) {
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}
